import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import moment from 'moment';
import ActivityLogDetail from '@/components/ActivityLogDetail.vue';
import { ACTION_TRANSLATIONS, ENTITY_TYPE_TRANSLATIONS, ACTION_COLORS } from '@/constants/ActivityLogConstants';
let ActivityLog = class ActivityLog extends Vue {
    actionFilter = '';
    entityTypeFilter = '';
    searchQuery = '';
    selectedEntry = null;
    detailDialogVisible = false;
    actionOptions = [
        { text: 'Vše', value: '' },
        { text: 'Vytvořeno', value: 'CREATE' },
        { text: 'Upraveno', value: 'UPDATE' },
        { text: 'Smazáno', value: 'DELETE' },
    ];
    entityTypeOptions = [
        { text: 'Vše', value: '' },
        { text: 'Instruktor', value: 'instructor' },
        { text: 'Stupeň', value: 'grade' },
        { text: 'Ceník', value: 'pricing' },
        { text: 'Voucher', value: 'voucher' },
        { text: 'Transakce', value: 'transaction' },
        { text: 'Zůstatek', value: 'balance' },
        { text: 'Rezervace', value: 'reservation' },
        { text: 'Dětská škola', value: 'kidSchool' },
        { text: 'Pauza', value: 'pause' },
        { text: 'Provozní doba', value: 'operatingHours' },
    ];
    headers = [
        { text: 'Čas', value: 'timestamp', width: '180px' },
        { text: 'Uživatel', value: 'userName' },
        { text: 'Akce', value: 'action', width: '100px' },
        { text: 'Typ', value: 'entityType', width: '120px' },
        { text: 'ID', value: 'entityId', width: '100px' },
        { text: '', value: 'actions', sortable: false, width: '50px' },
    ];
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get entries() {
        return this.$store.getters['activityLog/entries'];
    }
    get loading() {
        return this.$store.getters['activityLog/loading'];
    }
    get error() {
        return this.$store.getters['activityLog/error'];
    }
    get hasMore() {
        return this.$store.getters['activityLog/hasMore'];
    }
    get filteredEntries() {
        let result = this.entries;
        // Filter by action
        if (this.actionFilter) {
            result = result.filter(e => e.action === this.actionFilter);
        }
        // Filter by entity type
        if (this.entityTypeFilter) {
            result = result.filter(e => e.entityType === this.entityTypeFilter);
        }
        // Search query (searches in userName, entityType, entityId)
        if (this.searchQuery) {
            const query = this.searchQuery.toLowerCase();
            result = result.filter(e => e.userName.toLowerCase().includes(query) ||
                e.entityType.toLowerCase().includes(query) ||
                e.entityId.toLowerCase().includes(query));
        }
        return result;
    }
    async mounted() {
        await this.$store.dispatch('activityLog/loadActivityLog', { reset: true });
    }
    async refresh() {
        await this.$store.dispatch('activityLog/loadActivityLog', { reset: true });
    }
    async loadMore() {
        await this.$store.dispatch('activityLog/loadActivityLog', { reset: false });
    }
    formatTimestamp(timestamp) {
        if (!timestamp) {
            return '-';
        }
        return moment(timestamp.toDate()).format('DD.MM.YYYY HH:mm:ss');
    }
    translateAction(action) {
        return ACTION_TRANSLATIONS[action] || action;
    }
    translateEntityType(entityType) {
        return ENTITY_TYPE_TRANSLATIONS[entityType] || entityType;
    }
    getActionColor(action) {
        return ACTION_COLORS[action] || 'grey';
    }
    truncateId(id) {
        if (!id) {
            return '-';
        }
        return id.length > 8 ? id.substring(0, 8) + '...' : id;
    }
    openDetail(entry) {
        this.selectedEntry = entry;
        this.detailDialogVisible = true;
    }
    closeDetail() {
        this.detailDialogVisible = false;
        this.selectedEntry = null;
    }
};
ActivityLog = __decorate([
    Component({
        components: {
            ActivityLogDetail,
        },
    })
], ActivityLog);
export default ActivityLog;
